import { QueryHookOptions } from '@apollo/client';
import { useQuery } from '@ts-gql/apollo';
import { OperationData, OperationVariables, gql } from '@ts-gql/tag';
import React from 'react';

export const JOB_RECURRENCE_HISTORY_LIST_QUERY = gql`
  query JobRecurrenceHistoryList($recurrenceId: String!) {
    jobRecurrenceHistoryList(input: { recurrenceId: $recurrenceId }) {
      cloudId
      name
      jobStatusId
      completedDate
      WfCreatedOnUTC
      WfDeletedOnUTC
    }
  }
` as import('../../__generated__/ts-gql/JobRecurrenceHistoryList').type;

export type JobRecurrenceHistoryListQueryVariables = OperationVariables<
  typeof JOB_RECURRENCE_HISTORY_LIST_QUERY
>;
export type JobRecurrenceHistoryListQueryResult = OperationData<
  typeof JOB_RECURRENCE_HISTORY_LIST_QUERY
>;

export type JobRecurrenceHistoryListResult = NonNullable<
  ReturnType<typeof processData>
>[number];

// TODO WOKFLOW-333 add a hook hook for this that marries the result up to the status
export const useJobRecurrenceHistoryList = (
  options: QueryHookOptions<
    JobRecurrenceHistoryListQueryResult,
    JobRecurrenceHistoryListQueryVariables
  >
) => {
  const variables = options.variables as JobRecurrenceHistoryListQueryVariables;

  const res = useQuery(JOB_RECURRENCE_HISTORY_LIST_QUERY, {
    context: { service: 'core' },
    variables,
    ...options,
  });

  return React.useMemo(() => ({ ...res, data: processData(res.data) }), [res]);
};

export function processData(
  data: JobRecurrenceHistoryListQueryResult | undefined
) {
  const raw = data?.jobRecurrenceHistoryList;
  const results =
    raw &&
    raw.map((h) => ({
      ...h,
      completedDate: h.completedDate && new Date(h.completedDate),
      WfCreatedOnUTC: h.WfCreatedOnUTC && new Date(h.WfCreatedOnUTC),
      WfDeletedOnUTC: h.WfDeletedOnUTC && new Date(h.WfDeletedOnUTC),
    }));
  return results;
}
